import "./message.scss";
import { useEffect } from "react";
import { useCountdown } from "../../services/countdown";

const Message = ({ scoreDoc, nextFlipTime }) => {
    const { days, hours, minutes, seconds, updateTargetDate } =
        useCountdown(nextFlipTime);

    useEffect(() => {
        updateTargetDate(nextFlipTime);
    }, [nextFlipTime]);

    const isReady = days + hours + minutes + seconds <= 0;

    if (isReady) {
        return (
            <p className="message-ready">Tap the coin to flip!</p>
        );
    }

    return (
        <div className="message">
            <div className="show-counter-wrapper">
                <h3>Next flip in</h3>
                <div className="show-counter">
                    <DateTimeDisplay value={hours} type="Hours" />
                    <span>:</span>
                    <DateTimeDisplay value={minutes} type="Mins" />
                    <span>:</span>
                    <DateTimeDisplay value={seconds} type="Secs" />
                </div>
            </div>
        </div>
    );
};

const DateTimeDisplay = ({ value, type }) => {
    return (
        <div className="countdown">
            <span className="value">{value}</span>
            <span className="type">{type}</span>
        </div>
    );
};

export default Message;
